module.exports = __webpack_public_path__ + "img/coupon.0ccd4215.svg";